import React, { Component } from 'react';
import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.snow.css'; // ES6
import MetaTags from 'react-meta-tags';

import StaticStyles from './Static.css'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import utilities from './components/Utilities';
let Utilities = new utilities();

class StaticPage extends Component {

    constructor(props) {

        super(props);

        this.state = {
            editing: false,
            text: "<p>Loading</p>"
        }

    }

    handleChange = (value) => {
        this.setState({ text: value })
    }

    edit = () => {

        this.setState({
            editing: true
        })

    }

    save = () => {

        window.globalVars.server.api({
            method: "post",
            url: "/api/static/content/" + this.props.type,
            data: {
                text: this.state.text
            },
            then: function(res) {

                this.setState({
                    editing: false
                })

                this.get();

            }.bind(this),
            catch: function(e) {

            }.bind(this)
        })

    }

    get = () => {

        window.globalVars.server.api({
            method: "get",
            url: "/api/static/content/" + this.props.type,
            data: {},
            then: function(res) {

                if ( (Utilities.isENU(res.data.data)) || (Utilities.isENU(res.data)) ) {

                    this.setState({
                        text: "<p>Error Loading</p>"
                    })

                } else {

                    this.setState({
                        text: res.data.data
                    })

                }

            }.bind(this),
            catch: function(e) {

            }.bind(this)
        })

    }

    componentDidMount() {

        window.scrollTo({top: 0, left: 0, behavior: "smooth"});

        if (this.props.type === "terms") {
            document.title = window.globalVars.pageTitleBefore + "Terms & Conditions" + window.globalVars.pageTitleAfter;
        } else if (this.props.type === "privacy-policy") {
            document.title = window.globalVars.pageTitleBefore + "Privacy Policy" + window.globalVars.pageTitleAfter;
        } else if (this.props.type === "shipping") {
            document.title = window.globalVars.pageTitleBefore + "Shipping & Delivery" + window.globalVars.pageTitleAfter;
        }

        this.get();

    }

    render() {

        let user = JSON.parse(localStorage.getItem("user"));
        let editBtn = ""

        if ( (!Utilities.isENU(user)) && (user.type < 3) ) {
            editBtn = <button className="save" onClick={() => {this.edit()}}>Edit</button>
        }

        return (
            <div className="static-container">

                { (this.props.type === "terms" || this.props.type === "privacy-policy") &&
                    <MetaTags>
                        <meta name="robots" content="noindex" />
                        <meta name="googlebot" content="noindex" />
                        <meta id="meta-description" name="description" content="If you have enquiries, comments and feedback in relation to FrameIT, reach out to us by completing the form on our contact page." />
                    </MetaTags>
                }

                {this.props.type === "shipping" &&
                    <MetaTags>
                        <meta id="meta-description" name="description" content="If you have enquiries around our shipping and delivery options please find out more information here. For all other enquiries please get in touch." />
                        <meta name="robots" content="noindex" />
                        <meta name="googlebot" content="noindex" />
                    </MetaTags>
                }
                
                <div className="main-container">
                    <div className="static">
                        { (!this.state.editing) ?
                            <div className="content-container">
                                <div className="content" dangerouslySetInnerHTML={{__html: this.state.text}}></div>
                                {editBtn}
                            </div>
                            :
                            <div className="editor">
                                <ReactQuill
                                    value={this.state.text}
                                    onChange={this.handleChange}
                                />
                                <button className="save" onClick={() => {this.save()}}>Save</button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );

    }

}

export default StaticPage;



// WEBPACK FOOTER //
// ./src/Static.js